import {
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
  inject,
} from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

import { FeatureFlagsService } from '../../../services';
import { DialogService } from '../../services';
import { GoogleAnalyticsService } from '../../services/ga/google-analytics.service';
import { SubCommandDialogComponent } from './sub-command-dialog/sub-command-dialog.component';

@Component({
  selector: 'phoenix-command-menu',
  standalone: true,
  template: ``,
})
export class CommandMenuComponent implements OnInit, OnDestroy {
  @ViewChild('dialog') dialog!: ElementRef;
  @Input() value: string = '';
  isDialogOpen = false;
  featureFlagsService = inject(FeatureFlagsService);

  dialogService = inject(DialogService);
  matDialog = inject(MatDialog);
  dialogRef!: MatDialogRef<any>;
  gaService = inject(GoogleAnalyticsService);

  constructor() {
    this.listener = this.listener.bind(this);
  }

  listener(e: KeyboardEvent) {
    if (this.featureFlagsService.isOn('show_cmdk_command_dialog')) {
      const isCtrlK = e.key === 'k' && (e.ctrlKey || e.metaKey);
      if (isCtrlK) {
        e.preventDefault();
        if (this.isDialogOpen) {
          this.isDialogOpen = false;
          this.matDialog.closeAll();
        } else {
          this.dialogRef = this.matDialog.open(SubCommandDialogComponent, {
            width: '500px',
          });

          this.isDialogOpen = true;

          // send custom event to track the command palette action
          this.gaService.eventEmitter('q6_tracking_command_palette', {
            q6_tracking_command_palette: this.isDialogOpen,
          });

          this.dialogRef.afterClosed().subscribe(() => {
            this.isDialogOpen = false;
          });
        }
      }
    }
  }

  ngOnInit() {
    document.addEventListener('keydown', this.listener);
  }

  ngOnDestroy() {
    document.removeEventListener('keydown', this.listener);
  }
}
